<template>
    <auth-container>
        <h1 class="mb-12 text-center text-xl font-semibold">
            Passwort zurücksetzen
        </h1>
        <input-text
            class="mb-5 w-96"
            :name="'email'"
            :id="'email'"
            v-model="state.user.email"
            :label="'E-Mail'"
            :labelClass="'bg-white'"
        />
        <input-text
            class="mb-5 w-96"
            :name="'email_confirmation'"
            :id="'email_confirmation'"
            v-model="state.user.email_confirmation"
            :label="'E-Mail wiederholen'"
            :labelClass="'bg-white'"
            @enter="RESET_PASSWORD(state.user)"
        />

        <custom-button
            @click="RESET_PASSWORD(state.user)"
            class="w-96 h-11"
            :text="'Passwort zurücksetzen'"
            :bgColor="'bg-primary'"
            :textColor="'text-white'"
            :id="'password-reset-button'"
        />
        <router-link
            tag="h4"
            :to="{ name: 'Login' }"
            class="absolute bottom-5 cursor-pointer text-grey transition-colors hover:text-grey-dark"
        >
            Login
        </router-link>
    </auth-container>
</template>

<script>
import { defineComponent, reactive } from "vue";
import CustomButton from "../../components/input/CustomButton.vue";
import InputText from "../../components/input/InputText.vue";
import { AUTH_TYPES, HELPER_TYPES, STORE_TYPES } from "../../store/types";

import { useStore } from "vuex";
import AuthContainer from "./helpers/AuthContainer.vue";
import { useRouter } from "vue-router";
import { getData } from "../../common/dataHelper";
export default defineComponent({
    name: "PasswordReset",
    components: { InputText, CustomButton, AuthContainer },
    setup() {
        const store = useStore();
        const router = useRouter();
        const state = reactive({
            user: {
                email: "",
                email_confirmation: "",
            },
        });
        /**
         * functions
         */
        async function RESET_PASSWORD(user) {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "password-reset-button"
            );
            const result = await store.dispatch(
                `${STORE_TYPES.AUTH}/${AUTH_TYPES.RESET_PASSWORD}`,
                {
                    user,
                }
            );
            if (getData(result, "status") == 200) {
                router.push("/login");
            }
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "password-reset-button"
            );
        }

        return {
            state,
            RESET_PASSWORD,
        };
    },
});
</script>

<style></style>
